// Func = limiting Scope for this file
(function(){

	$(document).ready(function () {
		// const property_form = document.getElementById('property-form');
		// if(property_form){
		// 	const form_select = property_form.querySelector('select');
		// 	form_select.addEventListener('change', function(){
		// 		const this_data_action = this.selectedOptions[0].dataset.action;
		// 		property_form.action = this_data_action;
		// 	});
		// 	property_form.addEventListener('submit', function(event){
		// 		const this_action = form_select.value;
		// 		const form_error = property_form.querySelector('.form-error');
		// 		if(this_action == ''){
		// 			event.preventDefault();
		// 			form_error.innerHTML = 'Please select an option';
		// 		}else{
		// 			form_error.innerHTML = '';
		// 		}
		// 	})
		// }

		$('#property-form #property').change(function() {
			var data = $(this).children("option:selected").attr('data-action');
			var dataaction = data.split("?");
			$('#property-form').attr('action',dataaction[0]);
			$("#property-form input[type='hidden']").remove();
			if (typeof dataaction[1]  !== "undefined") {
				var datafields = dataaction[1].split("&");
				$.each( datafields, function( key, value ) {
					var datasubfields = value.split("=");
					$('#property-form').prepend('<input type="hidden" name="'+datasubfields[0]+'" value="'+datasubfields[1]+'">');
				});
			}
        });

		$('.join').on('click', function() {
        	ga('send', 'event', 'sign in', 'outbound', 'marriott.com');
        });
        $('.languages__active').on('click', function() {
        	$('.languages__options').slideToggle();
		});
		$('.mobile-toggle').on('click', function() {
        	if($('#booking-form').hasClass('open')) {
				$('#booking-form').removeClass('open');
				$('.mobile-toggle').html('Book Now');
			} else {
				$('#booking-form').addClass('open');
				$('.mobile-toggle').html('close');
			}
		});
		$('.header__menu').on('click', function() {
			if($(this).hasClass('active')) {
				$(this).removeClass('active');
				$('.header__menu--label').html('Our Properties');
			} else {
				$(this).addClass('active');
				$('.header__menu--label').html('close');
			}
        	$('.dropdown').slideToggle();
		});
		$('.columns__gallery').slick({
			slidesToShow:3,
			responsive: [
				{
				  breakpoint: 767,
				  settings: {
					slidesToShow: 1
				  }
				}
			  ]
		});
		if (window.matchMedia("(max-width: 768px)").matches) {
			/* the viewport is less than 768 pixels wide */
			$('.columns__list').slick({
				slidesToShow:1
			});
		} 
		
 
		//create dropdown menu
		var navigation = '';
		var widget_properties = '';
		var signup_location = '<option value="" selected>Select Property</option>';
		$('.hotel').each(function(i, obj) {
			navigation += '<a href="https://www.marriott.com/'+$(this).attr('data-marsha')+'" target="_blank">'+$(this).attr('data-title')+'</a>'; 
			if($('#booking-form').length > 0) {
				widget_properties += '<div class="selector__option" data-val="'+$(this).attr('data-marsha')+'" data-field="propertyCode">'+$(this).attr('data-title')+'</div>'; 
			}
			if($('#fe4101').length > 0) {
				signup_location += '<option>'+$(this).attr('data-title')+'</option>'; 
			}
		});
		$('.dropdown').prepend(navigation);
		if($('#booking-form').length > 0) {
			$('.select_property').html(widget_properties);
		}
		if($('#fe4101').length > 0) {
			$('#fe4101').html(signup_location); 
		}
		
		$('.sym-slides').slick();

		//Widget 
		if($('#dates').length > 0) {
			var today = new Date(); 
			var tomorrow = new Date();
			tomorrow.setDate(tomorrow.getDate() + 1);
			var dateInput = document.querySelector('#dates');
			//dateInput.value = fecha.format(today, 'MMM DD YY') + ' - ' + fecha.format(tomorrow, 'MMM DD YY');
	
			var datepicker = new HotelDatepicker(dateInput, {
				format: 'MM/DD/YYYY',
				onSelectRange: function() {
					var selectedDates = datepicker.getValue();
					selectedDates = selectedDates.split(" - ");
					$('#fromDate').val(fecha.format(new Date(selectedDates[0]), 'MM/DD/YYYY'));
					$('#toDate').val(fecha.format(new Date(selectedDates[1]), 'MM/DD/YYYY'));
				}
	
			});
		}  
	
		$('.fake-input').click(function(){
			$(this).toggleClass('open');
			$(this).siblings('.selector').slideToggle();
		});	

		$('.selector__custom--action').click(function(){
			if(!$(this).hasClass('inactive')) {
				//Setup variables
				var $singular = $(this).parent().attr('data-singular'),
				$plural = $(this).parent().attr('data-plural'),
				$field = $(this).parent().attr('data-field'),
				$min = $(this).parent().attr('data-min'),
				$max = $(this).parent().attr('data-max'),
				$current_value = $('input[name='+$field +']').val();
				
				//Increase and decrease process
				if($(this).hasClass('increase')) {
					var $new_value = parseInt($current_value)+1;
					if($new_value > $min) {
						$(this).siblings('.decrease').removeClass('inactive');
					}
					if($new_value == $max) {
						$(this).addClass('inactive');
					}
				} else {
					var $new_value = parseInt($current_value)-1;
					if($new_value == $min) {
						$(this).addClass('inactive');
					}
					if($new_value < $max) {
						$(this).siblings('.increase').removeClass('inactive');
					}
				}

				//Update labels
				if($new_value > 1) {
					$(this).siblings('.selector__custom--total').html($new_value+' '+$plural);
					$("span[data-selector='"+$singular+"']").html($new_value+' '+$plural);
				} else {
					$(this).siblings('.selector__custom--total').html($new_value+' '+$singular);
					$("span[data-selector='"+$singular+"']").html($new_value+' '+$plural);
				}

				//Update hidden field
				$('input[name='+$field +']').val($new_value);
				
				//Check number of guests per room
				//var $guests_per_room = (parseInt($('input[name=numAdultsPerRoom]').val())+parseInt($('input[name=childrenCount]').val()))/parseInt($('input[name=roomCount]').val());
				var $guests_per_room = parseInt($('input[name=numberOfGuests]').val())/parseInt($('input[name=roomCount]').val());
				if($guests_per_room == 6) {
					$('.guests .selector__custom--action.increase').addClass('inactive');
				} else {
					$('.guests .selector__custom--action.increase').removeClass('inactive');
				}
			}
		});
		$('.selector__option').click(function(){
			var $value = $(this).attr('data-val');
			var $label = $(this).html();
			var $field = $(this).attr('data-field');

			$('input[name='+$field+']').val($value);
			$(this).parent().siblings('.fake-input').html($label);  
			$(this).parent().siblings('.fake-input').removeClass('open');  
			$(this).parent().slideUp();
		});

		//countdown
		$('.countdown').countdown({ 
			date: $(this).attr('data-date'),
			render: function(data) {
				$(this.el).html('<div class="unit"><span class="unit__digit">'+this.leadingZeros(data.days, 2) + '</span><span class="unit__label">days</span></div><div class="unit"><span class="unit__digit">'+this.leadingZeros(data.hours, 2) + '</span><span class="unit__label">hours</span></div><div class="unit"><span class="unit__digit">'+this.leadingZeros(data.min, 2) + '</span><span class="unit__label">min</span></div>');
			}
		});

		//Resort Template
		if($('#resort').length > 0 || $('#health').length > 0) {
			$( ".hotel" ).wrapAll('<div class="inline-hotels" /><div class="container" />');
		}
	});

}());